import React, { useContext, useEffect, useState } from "react";
import socket from "../config/SocketConfig";
import { getToken, removeToken } from "../Data/services/localStorageService";
import { useDispatch } from "react-redux";
import { increaseCount, setCount } from "../Data/features/chatSlice";

const SocketContext = React.createContext();

export function useSocket() {
  return useContext(SocketContext);
}

export function SocketProvider({ children }) {
  const [isSocketConnected, setIsSocketConnected] = useState(false);
  const api_token = getToken();
  const dispatch = useDispatch();
  // console.log(api_token);

  useEffect(() => {
    if (api_token) {
      socket.connectToSocket(
        api_token,
        () => {
          setIsSocketConnected(false);
          // window.location.reload();
          // removeToken();
        },
        () => {
          setIsSocketConnected(true);
        }
      );
    } else {
      socket?.disconnect();
    }
    return () => socket?.disconnect();
  }, [api_token]);

  useEffect(() => {
    if (isSocketConnected) {
      // socket.on("newRoom_", (data) => {
      //   socket.emit(
      //     "_joinRoom",
      //     data?.data?.chat_room_slug || data?.data?.chat_room_id
      //   );
      // });

      socket.on("getChatThreads_", (data) => {
        const chatCount = data.data
          .map((chat) => chat.unread_message_count || 0)
          .reduce((sum, val) => sum + val, 0);

        // const chatCount = data.data.filter(
        //   (chat) => (chat.unread_message_count || 0) > 0
        // ).length;

        // console.log(chatCount);

        dispatch(setCount(chatCount));
      });

      socket.on("receivedMessage_", (data) => {
        dispatch(increaseCount(1));
      });

      socket.emit("_getChatThreads");
    }
    return () => {
      if (isSocketConnected) {
        socket.dispose("receivedMessage_");
        socket.dispose("getChatThreads_");
      }
    };
  }, [isSocketConnected]);

  return (
    <SocketContext.Provider value={{ socket, isSocketConnected }}>
      {children}
    </SocketContext.Provider>
  );
}
